export default __webpack_public_path__ + "static/jr-icons-12d9d4d52a957e83637d2e1c11e65fa8.png";